import { Component } from '@angular/core';
import { isK3000domain } from './core/common';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ExternalRedirectService } from './services/external-redirect.service';
import { environment } from 'src/environments/environment';
import { CommonModalWindowComponent } from './components/dialogs/common-modal-window/common-modal-window.component';
import { RouterOutlet } from '@angular/router';
import { RootLangDirective } from './utils/directives/root-lang.directive';
import { DeviceScreenAdjusterDirective } from './utils/directives/device-screen-adjuster.directive';
import { MainClickDirectiveDirective } from './utils/directives/main-click-directive.directive';
import { AuthService } from './services/auth/auth.service';

@Component({
    selector: 'asg-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [MainClickDirectiveDirective, DeviceScreenAdjusterDirective, RootLangDirective, RouterOutlet, CommonModalWindowComponent]
})
export class AppComponent {
  private titleAlinea = 'PROJECT.ALINEA';
  private titleK3000 = 'PROJECT.K3000';

  constructor(
    private titleService: Title,
    private translate: TranslateService,
    private externalRedirect: ExternalRedirectService,
    private authService: AuthService,
  ) {
    this.authService.clearCloudIfNewBrowserSession();
    this.getTranslatedTitle();
    this.checkForExternalRedirect();
  }

  private checkForExternalRedirect() {
    if (document && document.referrer) {
      const ref = document.referrer;
      const result = environment.externalRedirectReferrers.find(e => e.link === ref || ref.indexOf(e.link) > -1);
      if (result) {
        this.externalRedirect.docReferrerImagePath = result.params.loginLogoPath;
      }
    }
  }

  private getTitle() {
    if (isK3000domain()) {
      return this.titleK3000;
    } else {
      return this.titleAlinea;
    }
  }

  private getTranslatedTitle() {
    this.translate.onLangChange.subscribe(() => {
      this.translate.get(this.getTitle()).subscribe(
          title => this.titleService.setTitle(title),
        );
    });
  }

}
